import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Heart, Lock } from "lucide-react";
import api, { assetUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { TipJar } from "@/components/TipJar";
import { SEO } from "@/components/SEO";
import { ShareButtons } from "@/components/ShareButtons";

export default function CornerPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/corner/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
    window.scrollTo(0, 0);
  }, [slug]);

  if (error) return <div className="py-32 text-center text-muted-foreground">Post not found.</div>;
  if (!post) return <div className="py-32 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto px-5 sm:px-8 py-14" data-testid="corner-post-page">
      <SEO title={post.title} description={post.summary} />
      <Link to="/corner" className="text-sm text-muted-foreground flex items-center gap-1.5 mb-10 hover:text-foreground">
        <ArrowLeft size={14} /> Bridgett's Corner
      </Link>
      <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-4">Bridgett's Corner</p>
      <h1 className="font-display text-4xl sm:text-5xl text-foreground mb-8" data-testid="corner-post-title">{post.title}</h1>
      {post.image && <img src={assetUrl(post.image)} alt={post.title} className="rounded-lg mb-10 w-full" />}
      {post.audio_url && <audio controls src={assetUrl(post.audio_url)} className="w-full mb-10" data-testid="corner-post-audio" />}
      {post.video_url && (
        <div className="aspect-video mb-10">
          <iframe src={post.video_url} title={post.title} className="w-full h-full rounded-lg" allowFullScreen data-testid="corner-post-video" />
        </div>
      )}
      <div className="prose-orec" data-testid="corner-post-content">
        {post.content.split("\n\n").map((para, i) => <p key={i} className="whitespace-pre-wrap">{para}</p>)}
      </div>
      {post.locked && (
        <div className="silk-card rounded-lg p-8 text-center mt-8 border border-primary/40" data-testid="corner-locked-card">
          <Lock size={22} className="text-primary mx-auto mb-3" />
          <p className="font-display text-xl text-foreground mb-2">Bridgett has more to say…</p>
          <p className="text-sm text-muted-foreground mb-6">The full Corner — every post, audio and video — is open to Community Members. Free during our founding launch year.</p>
          <Button asChild className="rounded-full px-8" data-testid="corner-locked-cta">
            <Link to="/membership">Become a Community Member</Link>
          </Button>
        </div>
      )}
      <div className="mt-14 border-t border-border pt-8">
        <div className="flex justify-center mb-8">
          <ShareButtons title={`${post.title} — Bridgett's Corner`} />
        </div>
        <div className="text-center">
          <p className="text-sm text-muted-foreground mb-4 inline-flex items-center gap-2"><Heart size={14} className="text-primary" /> Enjoyed this? Support Bridgett with a small tip.</p>
          <TipJar className="justify-center" />
        </div>
      </div>
    </div>
  );
}
